import clientUUID from '@/client.js';
import { domain } from '@/modules/common.js';

const loadJudete = (lang) => fetch(`${domain}/${lang}/electric/judete`, {
  method: 'get',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Client-UUID': clientUUID
  }
});

export default loadJudete;
